// extracted by mini-css-extract-plugin
export default {"root":"SortKit_root__GNEmy","headerTable":"SortKit_headerTable__T6sfm","placeHolderShimmer":"SortKit_placeHolderShimmer__T0ZVj"};